import React, { useState } from "react";
import Select from "react-select";

const convertExchangeRates = async (from, to) => {
  const response = await fetch(
    `https://fxrateservice.vercel.app/api/bananacrystal-rate?from=${from}&to=${to}`
  );
  const data = await response.json();
  return data;
};

const CurrencyConverter = ({ currencies }) => {
  const options = currencies.map((curr) => ({ label: curr, value: curr }));

  const [currencyData, setCurrencyData] = useState({
    currencyFrom: "",
    currencyTo: "",
  });

  const [convertedData, setConvertedData] = useState({ bananaCrystalRate: 0 });

  const handleSelectChange = (name, value) => {
    setCurrencyData((prev) => ({
      ...prev,
      [name]: value.value,
    }));
  };

  const convertCurrency = async () => {
    if (currencyData.currencyFrom === "" || currencyData.currencyTo === "") {
      return;
    }

    const data = await convertExchangeRates(
      currencyData.currencyFrom,
      currencyData.currencyTo
    );
    setConvertedData(data);
  };

  return (
    <div className="admin_currency_converter">
      <h1>Currency Converter</h1>
      <div className="admin_currency_converter_input">
        <Select
          className="admin_curr_select"
          options={options}
          placeholder="Currency From"
          onChange={(data) => handleSelectChange("currencyFrom", data)}
        />
        <Select
          className="admin_curr_select"
          options={options}
          placeholder="Currency To"
          onChange={(data) => handleSelectChange("currencyTo", data)}
        />
      </div>
      <div className="admin_current_converter_submit">
        <input placeholder="Amount" value={convertedData.bananaCrystalRate} />
        <button onClick={convertCurrency}>Convert</button>
      </div>
    </div>
  );
};

export default CurrencyConverter;
